import { useCallback, useReducer, useState, useContext } from 'react';
import ToastContext from 'src/contexts/toast-context';
import { useAPI } from 'src/services/api';
import formReducer from 'src/services/formReducer';

const useForm = ({
  apiPath = '',
  contacts = {},
  createFormData = () => {},
  initialValues = {},
  pageTitle = '',
}) => {
  const { handleError } = useContext(ToastContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  const [disableNext, setDisableNext] = useState(false);
  const api = useAPI();

  const [formState, dispatch] = useReducer(formReducer, {
    stepNumber: 0,
    isComplete: false,
    isLoading: false,
    contacts: contacts,
    formData: initialValues,
  });

  const handleStoreData = useCallback((formData) => {
    dispatch({ type: 'store', payload: { formData } });
    // eslint-disable-next-line
  }, []);

  const handleStepChange = useCallback((step) => {
    dispatch({ type: 'step-change', payload: step });
    // eslint-disable-next-line
  }, []);

  const handleNext = (formData) => {
    handleStoreData(formData);
    handleStepChange(formState.stepNumber + 1);
  };

  const handleBack = () => {
    handleStepChange(formState.stepNumber - 1);
  };

  const handleSubmit = async (data) => {
    try {
      handleStoreData(data);
      const formData = createFormData({ ...formState.formData, ...data });
      setIsLoading(true);
      await api.post(apiPath, formData);
      setIsLoading(false);
      setIsComplete(true);
    } catch (err) {
      handleError(err);
      setIsLoading(false);
      console.error(err);
    }
  };

  return {
    changeStep: handleStepChange,
    contacts: formState.contacts,
    disableNext: disableNext,
    formData: formState.formData,
    isComplete,
    isLoading,
    onBack: handleBack,
    onNext: handleNext,
    onSubmit: handleSubmit,
    setDisableNext: setDisableNext,
    stepNumber: formState.stepNumber,
    store: handleStoreData,
    pageTitle,
  };
};

export default useForm;
